/**
 * Route for `igaming-configurable-dashboards-per-operator-partn`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingConfigurableDashboardsPerOperatorPartnPage } from "../features/igaming-configurable-dashboards-per-operator-partn/IgamingConfigurableDashboardsPerOperatorPartnPage";

export const igamingConfigurableDashboardsPerOperatorPartnRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-configurable-dashboards-per-operator-partn",
	component: IgamingConfigurableDashboardsPerOperatorPartnPage,
});

export default igamingConfigurableDashboardsPerOperatorPartnRoute;
